import { render, staticRenderFns } from "./RdiClosure.vue?vue&type=template&id=36b4baf6"
import script from "./RdiClosure.vue?vue&type=script&lang=js"
export * from "./RdiClosure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports